import React from 'react';

const LogoComponent = () => <div className='logo' />;

export default LogoComponent;



// WEBPACK FOOTER //
// ./src/app/Routing/Header/Logo.jsx